export const PUBLIC_HOME_ROUTE = '/'
export const APP_ROUTE = '/app'
export const APP_PAPERS_ROUTE = `${APP_ROUTE}/papers`
export const APP_GALLERY_ROUTE = `${APP_ROUTE}/gallery`
export const APP_ANALYTICS_ROUTE = `${APP_ROUTE}/analytics`
export const LEGACY_PAPERS_ROUTE = '/papers'

export const paperRoute = (paperId: string) => `${APP_PAPERS_ROUTE}/${paperId}`

export const normalizeAppRoute = (route: string) => {
  if (
    route === LEGACY_PAPERS_ROUTE ||
    route.startsWith(`${LEGACY_PAPERS_ROUTE}/`) ||
    route.startsWith(`${LEGACY_PAPERS_ROUTE}?`) ||
    route.startsWith(`${LEGACY_PAPERS_ROUTE}#`)
  ) {
    return `${APP_PAPERS_ROUTE}${route.slice(LEGACY_PAPERS_ROUTE.length)}`
  }

  return route
}

export const loginRedirectRoute = (redirectTo: string = APP_ROUTE) =>
  `/login?redirect=${encodeURIComponent(redirectTo)}`

export const signupRedirectRoute = (redirectTo: string = APP_ROUTE) =>
  `/signup?redirect=${encodeURIComponent(redirectTo)}`
